import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/global-error.tsx");
